import React, { useEffect, useContext} from 'react'
import {Card, CardHeader, CardContent, CardActions, Typography, Button, Table, TableRow, TableCell, TableBody} from '@mui/material'
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Axios from 'axios'
import {useHelper} from '../hooks/useHelper'
import { NuevaInscripcionNew } from './NuevaInscripcionNew';
import {v4 as uuidv4} from 'uuid';
import { formularioContext } from '../contextos/FormularioContext'
import { CheckCircleIcon,ChevronDoubleRightIcon } from '@heroicons/react/16/solid';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';

export const Precios = ({id_evento,volverInicio,evento,selectItem})=>{
    const [productos,setProductos] = React.useState([])
    const {formatearMontoMoneda}= useHelper()
    const [idEvValorSeleccionado,setIdEvValorSeleccionado] = React.useState(null)
    const [idEventoValorTemp,setIdEventoValorTemp] = React.useState(null)
    const {updateEventoValorSeleccionado,
            validarMinistroEventoSeleccionado,
            datos,
            buscarHabilitacionExterno,datosMinistroOk,
        pedirDatosMinExterno,setPedirDatosMinExterno} = useContext(formularioContext)
    const {hacerScroll} = useHelper();
    const navigate = useNavigate();

    const buscarEventosValor = async (id_evento,setEnSeleccion)=>{
        try{
            const {data} = await Axios.get(process.env.NODE_ENV =='development' ? `http://localhost:3020/api/tablasgenerales/eventosvalor/${id_evento}`:`https://uadapi.uad.digital/api/tablasgenerales/eventosvalor/${id_evento}`)
            setProductos(data)
        }catch(err){
            alert(err)
        }
    }

    useEffect(()=>{
        if(id_evento){
            buscarEventosValor(id_evento)
        }
    },[id_evento])

    // useEffect(()=>{
    //     if(productos.length==1 && datos.ministroUad=='ministroUad'){
    //         seleccionarEvValor(productos[0])
    //     }else{
    //         setIdEvValorSeleccionado(null)
    //     }
    // },[productos])

    // useEffect(()=>{
    //    updateEventoValorSeleccionado(idEvValorSeleccionado)
    //     // setTimeout(() => {
    //     //     hacerScroll("it-select")
    //     // }, 1000);
    // },[idEvValorSeleccionado])

    // useEffect(()=>{
    //      if(datos.ministroUad=='externo' && datosMinistroOk()[0]){
    //         continuarSeleccion(idEventoValorTemp)
    //         setIdEventoValorTemp(null)
    //     }
    // },[pedirDatosMinExterno])

    const seleccionarEvValor = async (idEventoValor)=>{

        selectItem(idEventoValor)

        if(datos.ministroUad=='ministroUad' || datosMinistroOk()[0]){
            continuarSeleccion(idEventoValor)
        }else{
            setIdEventoValorTemp(idEventoValor)
            setPedirDatosMinExterno(true)
        }
    }
    
    const continuarSeleccion = async (idEventoValor)=>{
        const validacion = validarMinistroEventoSeleccionado(null,idEventoValor);

        if(datos.ministroUad=='externo' && idEventoValor?.validar_dni_externos){
            try{
                const resultado = await buscarHabilitacionExterno(idEventoValor.nro_opcion)
                if(!resultado){
                    Swal.fire({
                        html:'<p>El DNI ingresado no se encuentra autorizado</p><p>Por favor verifique que el número es correcto</p><p>Si su DNI debiera figurar como autorizado por favor contacte a la mesa de ayuda</p>',
                        icon: 'warning',
                        customClass: 'slow-animation',
                        confirmButtonColor: '#3085d6',
                    })  
                    return 
                }
            }catch(err){
                alert(err)
                return
            }
        }

        if(validacion[0]){
            setIdEvValorSeleccionado(idEventoValor)
            setTimeout(() => {
                hacerScroll("detalle-producto")
            }, 500);
        }else{
            alert(validacion[1])
        }
    }

    return <Box sx={{padding:'0.5rem',maxWidth:'500px',display:'flex',flexDirection:'column'}}>
    <Typography id='it-select' style={{margin:'1.5rem',marginBottom:'1rem',textAlign:'left'}} variant="h6"> {idEvValorSeleccionado ? 'Tipo de inscripción seleccionada:':' Opciones de inscripción:'}</Typography>
    <Table>
        <TableBody>
            {productos.filter(producto=>producto.activo && (!idEvValorSeleccionado || idEvValorSeleccionado?.id_evento_valor == producto.id_evento_valor)).map((item, index) => (
                <DetalleProducto navigate={navigate} listIndex={index+1} item={item} idEvValorSeleccionado={idEvValorSeleccionado} setIdSeleccionado={seleccionarEvValor} hayOtrosItems={true}/>
            ))}
        </TableBody>
    </Table>
    {idEvValorSeleccionado && <>
        {validarMinistroEventoSeleccionado(null,idEvValorSeleccionado)[0] && <NuevaInscripcionNew id_evento={id_evento}  eventoValorSeleccionado={idEvValorSeleccionado}/>}
        {!validarMinistroEventoSeleccionado(null,idEvValorSeleccionado)[0] && <p>{validarMinistroEventoSeleccionado(null,idEvValorSeleccionado)[1]}</p>}
    </>}        
  </Box>
}

const DetalleProducto = ({item,navigate,setIdSeleccionado,evento,hayOtrosItems,volverInicio,idEvValorSeleccionado})=>{
  const index = uuidv4();
  const {formatearMontoMoneda,rangoEdadEvento}= useHelper()

  return <>
        <TableRow>
            <TableCell>
                <Typography  variant="h5">{item?.detalle}</Typography>
                
                <div className="flex items-center">
                    {/* <span className="material-icons text-blue-600 mr-2">fiber_manual_record</span> */}
                    {/* <span>{item.detalle}</span> */}
                    <span>({item?.tipo_persona})</span>
                </div>
                <p>{item?.info_adicional}</p>

                <p>{rangoEdadEvento(item)}</p>
                <p>{item.matrimonio ? 'Promo matrimonio':'Entrada Individual'}</p>

            </TableCell>
            <TableCell>
                <Typography variant="h6" align="rigth" color="primary"
                sx={{
                cursor: 'pointer',
                '&:hover': {
                fontWeight: 'bold',
                },
                }}
                onClick={()=>setIdSeleccionado(item)}
                //onClick={()=>navigate(`/inscripcion/item/${item.id_evento}/${item.id_evento_valor}`)}
                >
                        $ {formatearMontoMoneda(item.valor_mp)}
                </Typography>
            </TableCell>
    </TableRow>
  </>
 
}